export const SummaryState = {
	url: '/summary/:consultationId',
	title: 'Consultation Summary',
	template: '<summary-page></summary-page>',
	params: {
		consultationId: {
			type: 'path',
			squash: true,
		},
	},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName "summaryPageMod" */
			'@Containers/builder-summary-page/summary-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
	resolve: [
		{
			token: 'stateStatus',
			policy: {when: 'EAGER'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (ResolveSvc, trans) =>
				ResolveSvc.validateConsultationPrivate({status: 'draft', ...trans.params()}).catch(state =>
					trans.router.stateService.go(state.name, state.params)
				),
		},
	],
};

export const SummaryInspectorState = {
	url: '/inspector/:consultationId/:proposalId',
	title: 'Proposal Inspector',
	template: '<summary-inspector-page></summary-inspector-page>',
	params: {consultationId: null, proposalId: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "summaryInspectorPageMod" */
			'@Containers/builder-summary-page/summary-inspector-page.cmp.js'
		)
			.then(m => $ocLazyLoad.load({name: m.default}))
			.catch(err => $log.error(err));
	},
};
